module.exports = __webpack_public_path__ + "img/blue.7fbf9b84.png";